import { Button, Typography } from '@navi/web-ui/lib/primitives';
import ErrorIconOutline from '@cp/src/assets/icons/ErrorIconOutline';

interface UnsavedChangesFooterProps {
  onConfirmExit: () => void;
  onCancelExit: () => void;
}

const UnsavedChangesFooter = (props: UnsavedChangesFooterProps) => {
  const { onConfirmExit, onCancelExit } = props;
  return (
    <div className="flex flex-col gap-3">
      <div className="flex gap-2">
        <div className="w-[20px] pt-[2px]">
          <ErrorIconOutline size={20} />
        </div>
        <div className="flex flex-col">
          <Typography variant="h4" color="var(--navi-color-red-base)">
            Your changes will not be saved. Are you sure you want to exit?
          </Typography>
        </div>
      </div>
      <div className="ml-6 mt-2 flex gap-2">
        <Button variant="secondary" size="small" onClick={onConfirmExit}>
          Yes
        </Button>
        <Button variant="primary" size="small" onClick={onCancelExit}>
          No
        </Button>
      </div>
    </div>
  );
};

export default UnsavedChangesFooter;
